/** All available account account types */
export enum AccountingAccountTypeEnum {
  /** Active account */
  ACTIVE = 'ACTIVE',
  /** Passive account */
  PASSIVE = 'PASSIVE',
  /** Active and passive account */
  ACTIVE_PASSIVE = 'ACTIVE_PASSIVE'
}
